function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from "prop-types";
import Dropzone from 'react-dropzone';

const UploadDropzone = ({
  className,
  accept,
  multiple,
  onUpload,
  children
}) => {
  const handleDrop = acceptedFiles => {
    onUpload && onUpload(acceptedFiles);
  };

  return React.createElement(Dropzone, {
    multiple: multiple,
    accept: accept,
    onDrop: handleDrop
  }, ({
    getRootProps,
    getInputProps
  }) => React.createElement("div", _extends({}, getRootProps(), {
    className: className
  }), React.createElement("input", getInputProps()), children));
};

UploadDropzone.propTypes = process.env.NODE_ENV !== "production" ? {
  onUpload: PropTypes.func
} : {};
UploadDropzone.defaultProps = {
  multiple: true,
  accept: "image/*, video/*, audio/*"
};
export default UploadDropzone;